import { render, TemplateResult } from 'lit';

/**
 * Allows rendering Lit templates in places where we expect a raw HTML string.
 * Useful for inter-op with external Javascript libraries such as bb.js or others, that
 * do not support rendering Lit components.
 *
 * @param templateResult
 * @return string
 */
export function litTemplateToString(templateResult: TemplateResult): string {
  const container = document.createElement('div');
  render(templateResult, container);
  return container.innerHTML;
}
